module.exports = __webpack_public_path__ + "625c611306bce05694e003d10ab568ed.svg";